import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
} from '@angular/core';
import { Button } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { AsyncPipe, NgComponentOutlet } from '@angular/common';
import { catchError, EMPTY, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { SafeHtmlPipe } from '../../../../shared/pipes/safe-html-pipe';
import { TextResourcePipe } from '../../../../shared/pipes/text-resource.pipe';
import { HttpResponseService } from '../../../../core/services/http-error-response.service';
import { UserApi } from '../../../../shared/services/api/user.api';

@Component({
  selector: 'app-announcement-dialog',
  imports: [
    SafeHtmlPipe,
    Button,
    TextResourcePipe,
    AsyncPipe,
    NgComponentOutlet,
    FormsModule,
  ],
  templateUrl: './announcement-dialog.html',
  styleUrls: ['./announcement-dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnnouncementDialog {
  protected header = input<string>();
  protected content = input<string>();
  protected id = input<number>();
  protected requiresConfirmation = input<boolean>();
  protected component = input<any>();
  readonly #destroyRef = inject(DestroyRef);
  readonly #userApi = inject(UserApi);
  readonly #httpResponseService = inject(HttpResponseService);

  constructor(public dynamicDialogRef: DynamicDialogRef) {}

  protected confirmAnnouncement(): void {
    this.#userApi
      .confirmAnnouncement$(this.id()!)
      .pipe(
        tap(() => {
          this.dynamicDialogRef.close();
        }),
        catchError((err) => {
          this.#httpResponseService.showErrorMessage(
            err,
            'Wystąpił błąd podczas potwierdzenia otrzymania komuniaktu',
          );
          return EMPTY;
        }),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe();
  }
}
